import React from "react";
import { motion } from "framer-motion";
import { Song } from "../../types/song";
import { convertMarkdownToHTML } from "../../utils/markdown";

interface BehindTheSongProps {
  song: Song;
}

const BehindTheSong: React.FC<BehindTheSongProps> = ({ song }) => {
  if (!song.story?.trim()) return null;

  return (
    <section className="py-12 px-6 bg-gradient-to-br from-purple-50 to-blue-50">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="max-w-3xl mx-auto"
      >
        <div className="text-center mb-6">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-3">Behind the Song</h2>
          <div className="w-24 h-1 bg-purple-600 mx-auto" />
        </div>
        <div
          className="bg-white rounded-2xl shadow-xl p-6 md:p-8"
          dangerouslySetInnerHTML={{ __html: convertMarkdownToHTML(song.story) }}
        />
      </motion.div>
    </section>
  );
};

export default BehindTheSong;
